function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.5 13.3c-6.904 0-12.5 3.296-12.5 10.2 0 .168.025.333.031.5H15v30h25V24h-.031c.006-.167.031-.332.031-.5 0-6.904-5.596-10.2-12.5-10.2z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M21.6 21h12v5h-12zM20 36h15v15H20z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M20 36h15v5H20zM33 43.8c0 1.105-.448 2-1 2s-1-.895-1-2 1-2 1-2 1 .895 1 2zM14.312 8.825L17.9 7.056l3.538 7.175L17.85 16zM40.537 8.825L36.95 7.056l-3.537 7.175L37 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.017 25c-1-12.906 21-12.906 21 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 27.1c0 1.105-.448 2-1 2s-1-.895-1-2 1-2 1-2 1 .895 1 2z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 14c.429-6.524 8.571-6.524 9 0M14.4 9l.8 12M40.6 9l-.8 12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 37c.351-1.248 3-1 3-1v15h-3s-2.25-6 0-14zM43 37c-.343-1.248-2.933-1-2.933-1v15H43s2.2-6 0-14z",
  strokeLinejoin: "round"
}));

var SvgBackpack = function SvgBackpack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackpack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Backpack.52428734.svg";
export { ForwardRef as ReactComponent };